module.exports = __webpack_public_path__ + "img/faces-icon.b53a7b75.webp";